<template >
  <div
    class="container-fluid p-0 relative min-vh-100"
    style="background-size: cover; background-position: center center"
    v-bind:style="{
      'background-image': 'url(/img/background/' + src + '.jpg)',
    }"
  >
    <div class="overimg"></div>

    <notifications></notifications>

    <div class="col-lg-12">
      <div class="row custom-col">
        <div class="col-xl-8 col-lg-8 col-md-8 nomov">
          <div class="hvh100">
            <layoutFooter class="foot-init"></layoutFooter>
          </div>
        </div>
        <div
          class="
            col-xl-4 col-lg-4 col-md-4 col-sm-8 col-12
            hvh100
            row
            align-items-center
            justify-content-center
            back-trans
          "
        >
          <div class="col-xl-8 col-lg-10 col-md-11 col-sm-9 col-12 custom-col">
            <div class="text-center">
              <h1 class="text-black d-block">Welcome!</h1>
              <img
                src="@/assets/img/rhombuss-dispath-pos.png"
                alt="rhombuss"
                class="logo-home d-block mb-5 text-center"
              />
            </div>

            <div class="mb-0">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form role="form" @submit.prevent="handleSubmit(login)">
                  <base-input
                    label="Email"
                    placeholder="Email"
                    :rules="{ required: true, email: true, min: 5 }"
                    name="Email"
                    v-model="user.email"
                  ></base-input>

                  <base-input
                    label="Password"
                    placeholder="Password"
                    :rules="{ required: true, min: 8 }"
                    name="Password"
                    type="password"
                    autocomplete="on"
                    v-model="user.password"
                  ></base-input>

                  <base-checkbox
                    id="remember"
                    name="remember"
                    class="text-dark"
                    v-model="rememberMe"
                    >Remember me</base-checkbox
                  >

                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      size="sm"
                      class="mt-3 mb-4"
                      >Sign in</base-button
                    >
                  </div>
                </form>
              </validation-observer>

              <div class="mt-3 text-center mb-5">
                <!--   <router-link to="/forgot-password" class="f2 d-block"
                  >Did you forget your password?</router-link
                > -->
                <a
                  href="https://www.rhombuss.com/"
                  class="f2 mt-3 d-block"
                  target="blank"
                  >Create Account</a
                >
              </div>

              <div class="loading mt-5" v-if="loader">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>

              <base-alert
                :type="alert.type"
                dismissible
                v-if="alert.status"
                class="alert-base"
              >
                <span class="alert-inner--icon"
                  ><i :class="alert.icon" class="mr-2"></i
                ></span>
                <span class="alert-inner--text"
                  ><strong>{{ alert.title }}</strong> {{ alert.message }}</span
                >
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </base-alert>
            </div>
          </div>
        </div>
      </div>
      <layoutFooter class="foot-init only-mov"></layoutFooter>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import layoutFooter from "../Theme/Layout/ContentFooter";
import endpoint from "../../Commons/Services";
import { ValidationObserver } from "vee-validate";
import moment from "moment-timezone";
export default {
  components: {
    layoutFooter: layoutFooter,
    ValidationObserver,
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      rememberMe: false,
      message: "",
      load: false,
      photos: [
        { id: 1, title: "Rhombuss", name: "backRhombuss1" },
        { id: 2, title: "Rhombuss", name: "backRhombuss2" },
        // { id: 3, title: "Rhombuss", name: "backRhombuss3" },
      ],
      src: "backRhombuss1",
      alert: {
        type: "",
        title: "",
        message: "",
        icon: "",
        class: "",
        status: false,
      },
      email_status: true,
      message_email: "",
    };
  },
  created() {
    localStorage.removeItem("es-login");
    this.setAction("not-content");
    this.setDate(moment.parseZone().utc(true));
    this.setQuery("");
    this.setBranch("");
    this.setSesion({
      token: "",
      role: "",
      id: "",
      account_type: { type: "", owner: "" },
    });
    this.setProfile({
      firts_name: "",
      last_name: "",
      image: "",
    });
    this.setSigOut(false);
    this.setReservation(null);
    this.setReservationId("");
    this.setDriverId("");
    this.setDrivers([]);
    this.src = this.photos[this.random()].name;
  },
  methods: {
    async login() {
      this.setLoader(true);
      this.alert.status = false;
      const isValid = await this.$refs.formValidator.validate();
      if (isValid) {
        try {
          let { data } = await endpoint.auth.services.login({
            email: this.user.email,
            password: this.user.password,
          });
          let role = data.data.role;
          if (role !== "admin") {
            this.setLoader(false);
            if (data.status) {
              this.setSesion(data.data);
              await this.getProfile();
              this.$router.push("/dispatch-panel");
            } else {
              this.loginrequired();
            }
          } else {
            this.setLoader(false);
            this.loginError();
          }
        } catch (error) {
          this.setLoader(false);
          if (error.response.status === 404) {
            let data = error.response.data.data;
            if (data.profile === "inactive") {
              this.loginWarning();
            } else {
              this.loginError();
            }
          } else {
            this.loginError();
          }
        }
      } else {
        this.setLoader(false);
        this.loginrequired();
      }
    },

    loginError() {
      this.alert = {
        type: "danger",
        title: "Error!",
        message: "Incorrect Email or Password Entered",
        icon: "flaticon-remove",
        class: "alert-danger",
        status: true,
      };
    },
    loginWarning() {
      this.alert = {
        type: "warning",
        title: "Important!",
        message: "This user is currently inactive",
        icon: "flaticon-warning-1",
        class: "alert-warning",
        status: true,
      };
    },
    loginrequired() {
      this.alert = {
        type: "danger",
        title: "Error!",
        message: "Enter all fields required",
        icon: "flaticon-remove",
        class: "alert-danger",
        status: true,
      };
    },
    random: function () {
      return Math.floor(Math.random() * this.photos.length);
    },
    ...mapActions(["getProfile"]),
    ...mapMutations([
      "setLoader",
      "setSesion",
      "setSigOut",
      "setProfile",
      "setDate",
      "setQuery",
      "setAction",
      "setReservation",
      "setReservationId",
      "setBranch",
      "setDriverId",
      "setDrivers",
    ]),
  },
  computed: {
    ...mapGetters(["loader", "sesion"]),
  },
};
</script>
